import { lazy } from "react"

export const QualityPassportsPage = lazy(() => import("./QualityPassportsPage"))